import { doc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../config';
import { DictionaryRow } from '../../../../types/dictionary';

interface UpdateDictionaryParams {
  dictionaryId: string;
  // CSV 差し替え時に更新する本体の項目（マッピングは dictionary_mappings 側で別途更新）
  rowCount?: number;
  csvColumns?: string[];
  rows?: DictionaryRow[];
  uploadedByUid: string;
  uploadedByName: string;
  uploadedByIcon: string | null;
  // 代理ログイン中の差し替えか（#3343）。true のとき uploadedByName には「事務局」を渡す。
  isProxy?: boolean;
  // 代理操作した運営スタッフの UID（#3343）。代理でなければ undefined。
  operatorId?: string | null;
}

type UpdateDictionaryValue =
  | string
  | number
  | boolean
  | string[]
  | DictionaryRow[]
  | Timestamp
  | null;

// 辞書本体（CSV データ）を更新する。CSV 差し替え時に rows / csv_columns / row_count を上書きする。
export const updateDictionary = async (params: UpdateDictionaryParams): Promise<void> => {
  const dictionaryRef = doc(db, 'dictionaries', params.dictionaryId);

  const isProxy = params.isProxy === true;

  const updateData: Record<string, UpdateDictionaryValue> = {
    uploaded_by_uid: params.uploadedByUid,
    uploaded_by_name: params.uploadedByName,
    uploaded_by_icon: params.uploadedByIcon,
    // 代理操作の記録（#3343）。差し替えでアップロード者が変わるため、
    // 代理でない場合も false / null を明示して前回の代理記録を消す。
    is_proxy: isProxy,
    operator_id: isProxy ? params.operatorId || null : null,
    updated_at: Timestamp.now(),
  };

  if (params.rowCount !== undefined) updateData.row_count = params.rowCount;
  if (params.csvColumns !== undefined) updateData.csv_columns = params.csvColumns;
  if (params.rows !== undefined) updateData.rows = params.rows;

  await updateDoc(dictionaryRef, updateData);
};
